<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                        <li :key="page.name" class="breadcrumb-item" v-for="page in pages">
                            <span v-if="page.router != null ">
                                <router-link :to="{name: page.router}">{{page.name}} </router-link>
                            </span>
                            <span :class="{'active':page.active}" v-else> {{page.name}} </span>

                        </li>
                    </ol>
                </div>
                <h4 class="page-title">{{title}}</h4>
            </div><!--end page-title-box-->
        </div><!--end col-->
    </div>
</template>

<script>
    export default {
        name: 'PageTitle',
        props: {
            title: String,
            pages: Array
        }
    };
</script>

<style scoped>

</style>
